import * as C from 'actions/constants';

export const blankState = {
  list: [],
  count: 0,
  report: {},
  loading: false,
};

const ReportReducer = (state = blankState, action) => {
  switch (action.type) {
    case C.LOAD_REPORTS:
    case C.LOAD_REPORT:
    case C.CREATE_REPORT:
    case C.DELETE_REPORT: {
      return { ...state, loading: true };
    }
    case C.LOAD_REPORTS_SUCCESS:
    case C.LOAD_REPORT_SUCCESS: {
      const { data } = action;
      return { ...state, loading: false, ...data };
    }
    case C.SET_REPORT: {
      const { data } = action;
      return { ...state, report: data };
    }
    case C.CLOSE_REPORT: {
      return { ...state, report: {} };
    }
    case C.DELETE_REPORT_SUCCESS:
    case C.CREATE_REPORT_SUCCESS:
    case C.DELETE_REPORT_ERROR:
    case C.CREATE_REPORT_ERROR:
    case C.LOAD_REPORTS_ERROR:
    case C.LOAD_REPORT_ERROR: {
      return { ...state, loading: false };
    }
    default:
      return state;
  }
};

export default ReportReducer;
